import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { CurrentUserHasRole } from '../../api/auth'
import { isFeatureEnabled } from '../../config';

export const ProtectedRoute = ({requiredRole, requiredFeature, ...props}) => 
    CurrentUserHasRole(requiredRole) && (!requiredFeature || isFeatureEnabled(requiredFeature))
    ? <Route {...props} />
    : <Redirect to="/authentication/login" />;